// extracted by mini-css-extract-plugin
module.exports = {"label":"CbCampaignFundingActions_label__3IL2f","provenance":"CbCampaignFundingActions_provenance__YNTCB","root":"CbCampaignFundingActions_root__2LmbA"};